import { Texto } from '@/components/atomos';
import { Heading } from '@chakra-ui/react';
import { ComponentProps, FC } from 'react';

export const TextoAviso: FC<ComponentProps<typeof Texto>> = (props) => {
  return (
    <Texto lineHeight={'tall'} textAlign={"justify"} {...props} />
  );
};

export const CabeceraSeccion: FC<ComponentProps<typeof Heading>> = (props) => {
    return <Heading size={"lg"} color={"bPink.400"} {...props}/>
};
